var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "form",
    [
      _c("v-select", {
        attrs: {
          outlined: "",
          dense: "",
          items: _vm.questionsListA,
          label: "Question 1"
        },
        model: {
          value: _vm.model.sq_A,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "sq_A", $$v)
          },
          expression: "model.sq_A"
        }
      }),
      _vm.isSelectedCustomA
        ? _c("v-text-field", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            attrs: {
              dense: "",
              outlined: "",
              label: "Please enter your question",
              clearable: "",
              name: "Question 1 Custom",
              "data-vv-as": "Question 1",
              "error-messages": _vm.errors.collect("Question 1 Custom")
            },
            model: {
              value: _vm.model.sq_A_custom,
              callback: function callback($$v) {
                _vm.$set(_vm.model, "sq_A_custom", $$v)
              },
              expression: "model.sq_A_custom"
            }
          })
        : _vm._e(),
      _c("v-text-field", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required",
            expression: "'required'"
          }
        ],
        attrs: {
          outlined: "",
          dense: "",
          "error-messages": _vm.errors.collect("Answer 1"),
          name: "Answer 1",
          label: "Answer 1",
          maxlength: "80"
        },
        model: {
          value: _vm.model.sqa_A,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "sqa_A", $$v)
          },
          expression: "model.sqa_A"
        }
      }),
      _c("v-select", {
        attrs: {
          outlined: "",
          dense: "",
          items: _vm.questionsListB,
          label: "Question 2"
        },
        model: {
          value: _vm.model.sq_B,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "sq_B", $$v)
          },
          expression: "model.sq_B"
        }
      }),
      _vm.isSelectedCustomB
        ? _c("v-text-field", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            attrs: {
              dense: "",
              outlined: "",
              label: "Please enter your question",
              clearable: "",
              name: "Question 2 Custom",
              "data-vv-as": "Question 2",
              "error-messages": _vm.errors.collect("Question 2 Custom")
            },
            model: {
              value: _vm.model.sq_B_custom,
              callback: function callback($$v) {
                _vm.$set(_vm.model, "sq_B_custom", $$v)
              },
              expression: "model.sq_B_custom"
            }
          })
        : _vm._e(),
      _c("v-text-field", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required",
            expression: "'required'"
          }
        ],
        attrs: {
          outlined: "",
          dense: "",
          "error-messages": _vm.errors.collect("Answer 2"),
          name: "Answer 2",
          label: "Answer 2",
          maxlength: "80"
        },
        model: {
          value: _vm.model.sqa_B,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "sqa_B", $$v)
          },
          expression: "model.sqa_B"
        }
      }),
      _c(
        "gg-btn",
        {
          staticClass: "mt-2 ml-0",
          attrs: {
            dark: "",
            color: "green",
            loading: _vm.loading,
            tile: ""
          },
          on: {
            click: _vm.saveAnswers
          }
        },
        [_vm._v(" Save Answers ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }